type TCoordinate = {
  x: number;
  y: number;
};

export type TGradient = {
  start: TCoordinate;
  end: TCoordinate;
  locations: number[];
  colors: string[];
};

export const defaultGradient: TGradient = {
  start: { x: 0.0, y: 0.69 },
  end: { x: 1.0, y: 0.31 },
  locations: [0, 0.5, 1.0],
  colors: ['#E33B6C', '#E76F6C', '#E9AF65'],
};

export const gradientToCssRule = (
  gradient: TGradient,
  direction?: 'horizontal' | 'vertical',
): string => {
  const colorsWithLocationsString = gradient.colors
    .map((color, index) => `${color} ${gradient.locations[index] * 100}%`)
    .join(', ');

  const destination = direction === 'vertical' ? 'bottom' : 'right';

  return `linear-gradient(to ${destination}, ${colorsWithLocationsString})`;
};
